import styled, { css } from 'styled-components'
import { Typography } from '../Typography'

const getGridColumns = (
  columns: number | { sm?: number; md?: number; lg?: number } | undefined
) => {
  if (!columns) return 'repeat(auto-fit, minmax(250px, 1fr))'

  if (typeof columns === 'number') {
    return `repeat(${columns}, 1fr)`
  }

  return css`
    grid-template-columns: repeat(${columns.sm || 1}, 1fr);
  `
}

export const GroupRoot = styled.fieldset<{ $disabled?: boolean }>`
  margin: 0;
  padding: 0;
  border: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.6;
      pointer-events: none;
    `}
`

export const Legend = styled.legend`
  padding: 0;
  margin-bottom: 0.5rem;
  display: block;
`

export const RequiredMark = styled.span`
  color: ${({ theme }) => theme.colors.danger};
  margin-left: 0.25rem;
`

export const Fields = styled.div<{
  $columns?: number | { sm?: number; md?: number; lg?: number }
  $gap?: number | string
  $layout?: 'horizontal' | 'vertical'
}>`
  display: grid;
  ${({ $columns }) =>
    typeof $columns === 'object'
      ? getGridColumns($columns)
      : css`
          grid-template-columns: ${getGridColumns($columns)};
        `}
  gap: ${({ $gap = '0.5rem' }) => (typeof $gap === 'number' ? `${$gap}px` : $gap)};

  ${({ $layout }) =>
    $layout === 'vertical' &&
    css`
      grid-template-columns: 1fr;
    `}
`

export const FieldWrapper = styled.div<{
  $width?: string | number
  $grow?: boolean
}>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;

  ${({ $width }) =>
    $width &&
    css`
      width: ${typeof $width === 'number' ? `${$width}px` : $width};
    `}

  ${({ $grow }) =>
    $grow &&
    css`
      flex: 1;
      grid-column: span 2;
    `}
`

export const FieldLabel = styled.label<{ $hidden?: boolean }>`
  ${({ $hidden }) =>
    $hidden &&
    css`
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border-width: 0;
    `}
`

export const FieldContent = styled.div<{
  $hasBefore?: boolean
  $hasAfter?: boolean
}>`
  /* display: flex; */
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`

export const Adornment = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.textSecondary};
  flex-shrink: 0;
`

export const HintText = styled(Typography)`
  margin-top: 0.25rem;
`

export const ErrorText = styled(Typography)`
  margin-top: 0.25rem;
  display: flex;
  align-items: flex-start;
  gap: 0.25rem;
`
